import React from 'react';
import { CheckSquare } from 'lucide-react';
export function ContentBreakdown() {
  const modules = ['Materiales: qué comprar, qué evitar y cuánto invertir', 'Aplicación: mezcla, tiempos, capas y terminación profesional', 'Técnicas premium: acabados que se cobran más caro', 'Superficies industriales: galpones, talleres y alto tránsito', 'Presupuesto y cobro: cómo cotizar sin quedarte corto'];
  return <section className="py-16 px-4 bg-[#0a0a0a]" aria-label="Contenido del Mega Pack" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-4 text-white uppercase tracking-tight" data-id="element-48">
          Un sistema completo. No un curso más.
        </h2>

        <p className="text-lg md:text-xl text-gray-400 text-center mb-10" data-id="element-49">
          El Mega Pack tiene 5 tomos que cubren desde los materiales hasta cómo
          cobrar:
        </p>

        <ul className="space-y-4 mb-12 list-none p-0" data-id="element-50">
          {modules.map((module, index) => <li key={index} className="flex items-start p-5 bg-[#1a1a1a] rounded-xl border border-amber-900/30 shadow-sm" data-id="element-51">
              <CheckSquare className="w-6 h-6 text-amber-500 mr-4 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-52" />
              <span className="text-lg font-medium text-gray-200" data-id="element-53">
                {module}
              </span>
            </li>)}
        </ul>

        <div className="bg-amber-900/20 text-amber-100 p-6 rounded-xl text-center border border-amber-800/40" data-id="element-54">
          <p className="text-lg md:text-xl font-bold" data-id="element-55">
            Cada tomo está pensado para que avances rápido y con seguridad.
          </p>
        </div>

        <div className="w-full h-px bg-gray-800 mt-16" aria-hidden="true" data-id="element-56"></div>
      </div>
    </section>;
}